import React from 'react';

/**
 * Footer Logo Component for ADGS
 * Uses the same design as the header Logo but with accent color (bright yellow)
 * Clean typography with subtle animations and professional appearance
 */
interface FooterLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  animated?: boolean;
}

const FooterLogo: React.FC<FooterLogoProps> = ({ 
  size = 'md', 
  className = '',
  animated = true 
}) => {
  // Size mappings for the logo box - EXACT same as header Logo
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10', 
    lg: 'w-12 h-12',
    xl: 'w-14 h-14'
  };

  // Animation classes
  const animationClasses = animated ? 'transition-all duration-300 hover:scale-105' : '';

  return (
    <div className={`flex items-center space-x-2 ${animationClasses} ${className}`}>
      {/* ADGS Logo with accent color (bright yellow) background - EXACT same text as header Logo */}
      <div className={`${sizeClasses[size]} bg-accent rounded-lg flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300`}>
        <span className="text-black font-bold text-base">ADGS</span>
      </div>
    </div>
  );
};

export default FooterLogo;
